// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__DmuFo","requiredAsterisk":"Info_requiredAsterisk__2R1En"};